var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": _vm.labelPosition,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "主动报废编号",
                                        prop: "sroCode",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "支持模糊查询",
                                        },
                                        model: {
                                          value: _vm.queryCondition.sroCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "sroCode",
                                              $$v
                                            )
                                          },
                                          expression: "queryCondition.sroCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "报废项目简介",
                                        prop: "projectSummary",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "支持模糊查询",
                                        },
                                        model: {
                                          value:
                                            _vm.queryCondition.projectSummary,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "projectSummary",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.projectSummary",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "产品名称",
                                        prop: "materialName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "支持模糊查询",
                                        },
                                        model: {
                                          value:
                                            _vm.queryCondition.materialName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "materialName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.materialName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: { label: "状态", prop: "status" },
                                    },
                                    [
                                      _c("ic-select", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          table: "TT_QUALITY_DEFECT",
                                          field: "STATUS",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: _vm.queryCondition.status,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "status",
                                              $$v
                                            )
                                          },
                                          expression: "queryCondition.status",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-transition",
                        [
                          _vm.isShow
                            ? _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "是否已下发STINV",
                                                prop: "isIssued",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder: "请选择",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .isIssued,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "isIssued",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.isIssued",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.isIssuedLists,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label: item.label,
                                                        value: item.value,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      attrs: {
                        type: "flex",
                        justify: "center",
                        align: "middle",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onSearch },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onReset },
                        },
                        [_vm._v("重置")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "arrowDown",
                          on: {
                            click: function ($event) {
                              _vm.isShow = !_vm.isShow
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                          _c("i", {
                            class: _vm.isShow
                              ? "el-icon-arrow-up iconBtn"
                              : "el-icon-arrow-down iconBtn",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "action-btn-row" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.QUALITY_DEFECT_ADD,
                      expression: "QUALITY_DEFECT_ADD",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onAdd },
                },
                [_vm._v("新增")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.QUALITY_DEFECT_DEL,
                      expression: "QUALITY_DEFECT_DEL",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "danger" },
                  on: { click: _vm.onDel },
                },
                [_vm._v("删除")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.QUALITY_DEFECT_EXPORT,
                      expression: "QUALITY_DEFECT_EXPORT",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onExport },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
          _c(
            "ux-grid",
            {
              ref: "plxTable",
              attrs: {
                data: _vm.tableData,
                checkboxConfig: {
                  checkMethod: _vm.selectable,
                  highlight: true,
                },
                "cell-class-name": _vm.setCellClass,
                "max-height": "600",
                "show-overflow": "tooltip",
                "highlight-current-row": "",
              },
              on: {
                "selection-change": _vm.selectionChange,
                "cell-click": _vm.cellClick,
              },
            },
            [
              _c("ux-table-column", {
                attrs: { align: "center", type: "checkbox", width: "80" },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "主动报废编号",
                  resizable: "",
                  "min-width": "80",
                  field: "sroCode",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onDetail(row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(row.sroCode))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "主动报废项目简介",
                  resizable: "",
                  "min-width": "120",
                  field: "projectSummary",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "报废启动日期",
                  resizable: "",
                  "min-width": "180",
                  field: "startDate",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "等级",
                  resizable: "",
                  "min-width": "100",
                  field: "grade",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "状态",
                  resizable: "",
                  "min-width": "90",
                  field: "statusI18n",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "是否已下发STINV",
                  resizable: "",
                  "min-width": "90",
                  field: "isIssued",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "下发时间",
                  resizable: "",
                  "min-width": "90",
                  field: "issueDate",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "发起人",
                  resizable: "",
                  "min-width": "90",
                  field: "creator",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryCondition.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.queryCondition.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                  "page-count": _vm.pages,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showDetailDialog,
            "append-to-body": "",
            width: "80%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDetailDialog = $event
            },
            close: _vm.closeDialog,
          },
        },
        [_vm.showDetailDialog ? _c("detailDialog") : _vm._e()],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }